import { render, staticRenderFns } from "./SupervisionUpload.vue?vue&type=template&id=260bc45c&scoped=true&"
import script from "./SupervisionUpload.vue?vue&type=script&lang=ts&"
export * from "./SupervisionUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SupervisionUpload.vue?vue&type=style&index=0&id=260bc45c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260bc45c",
  null
  
)

export default component.exports